/*
  Maison Cerisay - eigen gedrag op de productpagina.

  Twee dingen, allebei zonder bibliotheek:
    aftelbalk   dagelijkse klok naar 23:59:59, daarna de volgende dag
    3.12        sticky toevoegbalk op mobiel
    5           VOIR PLUS op de collectiepagina

  De aftelbalk rekent met de klok van de bezoeker. Dat is bewust: de balk
  belooft "vandaag tot 23h59", en dat moet kloppen met de tijd op het scherm
  van wie er kijkt.
*/
(function () {
  'use strict';

  /* ---------------------------------------------------------- aftelbalk */

  /*
    Telt af naar 23:59:59.999 van vandaag. Is dat moment voorbij, dan schuift
    het doel een dag op. Elke seconde opnieuw bepaald, dus de balk rolt vanzelf
    door naar de volgende dag zonder dat iemand iets hoeft in te stellen.

    Bewust geen vaste einddatum: dan zou de teller na die datum op nul blijven
    staan of verdwijnen.
  */

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function nextMidnight(now) {
    var end = new Date(now.getTime());
    end.setHours(23, 59, 59, 999);
    if (now.getTime() >= end.getTime()) {
      end.setDate(end.getDate() + 1);
    }
    return end;
  }

  function initDailyCountdown() {
    var bars = document.querySelectorAll('[data-mc-daily-countdown]');
    if (!bars.length) return;

    var clocks = [];
    for (var i = 0; i < bars.length; i++) {
      var c = bars[i].querySelector('[data-mc-daily-clock]');
      if (c) clocks.push(c);
    }
    if (!clocks.length) return;

    function tick() {
      var now = new Date();
      var left = Math.max(0, Math.floor((nextMidnight(now).getTime() - now.getTime()) / 1000));

      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var sec = left % 60;
      var text = pad(h) + ':' + pad(m) + ':' + pad(sec);

      for (var i = 0; i < clocks.length; i++) {
        if (clocks[i].textContent !== text) clocks[i].textContent = text;
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------------ 3.12 */

  function initStickyAtc() {
    var bar = document.querySelector('[data-mc-sticky]');
    if (!bar) return;

    // De echte toevoegknop, nadrukkelijk niet die in de balk zelf.
    function zoekKnop() {
      var k = document.querySelector(
        '.product-single__meta [data-add-to-cart], .product-single [data-add-to-cart]'
      );
      if (k) return k;
      var alle = document.querySelectorAll('[data-add-to-cart]');
      for (var i = 0; i < alle.length; i++) {
        if (!bar.contains(alle[i])) return alle[i];
      }
      return null;
    }

    var realBtn = zoekKnop();
    if (!realBtn) return;

    /* Zichtbaarheid van de balk, drie voorwaarden:
         1) de bezoeker is voorbij de echte toevoegknop gescrold,
         2) het product zit niet in de wagen,
         3) de cart drawer is dicht.
       Voorwaarde 2 en 3 zetten de balk hard uit (mc-atc-off, display none);
       is alles in orde, dan zet is-visible hem aan. Alles loopt door
       evalueer(), er zijn bewust geen losse handlers die elkaar kunnen
       overschrijven.

       Voorwaarde 1 wordt niet per scroll-frame gemeten. Niet omdat een
       telefoon scroll-events of requestAnimationFrame zou stilleggen tijdens
       het uitglijden -- in WebKit draaien die twee in dezelfde rendering-
       update, en sinds iOS 13 vuren scroll-events ook tijdens momentum
       gewoon door -- maar omdat de MEETWAARDE achterloopt. Op iOS scrolt het
       UI-proces en niet het web-proces, en de scrollpositie die de main
       thread kent loopt gegarandeerd achter op wat er op het scherm staat,
       minstens een frame en meer zodra het web-proces druk is. Bij een
       snelle fling verschuift de pagina honderden pixels per frame, dus
       getBoundingClientRect() kan er ver naast zitten. Valt de laatste
       scroll-melding op een verouderde stand en komt er daarna geen melding
       meer, dan blijft de balk in die verkeerde stand staan.

       Daarom vier onafhankelijke aanjagers, alle door evalueer():
         a) een IntersectionObserver op de knop. De browser meldt de
            verandering zelf; wij meten niets en kunnen dus niets missen.
            Bij gebundelde meldingen lezen we entries[entries.length - 1],
            de actuele stand. Een eerdere versie las entries[0], de oudste,
            en dat is waarom de observer toen leek te falen.
         b) hermeten op rustmomenten (touchend, scrollend, pageshow,
            orientationchange, resize, weer-zichtbaar). Op zo'n moment is de
            layout gesynchroniseerd, dus een directe meting klopt.
         c) een scroll-listener met een tijdslot in plaats van een grendel.
            Een tijdslot kan niet blijven hangen: de klok loopt altijd door.
         d) een slotmeting 150ms nadat het scrollen stil ligt. Die vangt het
            geval hierboven: de laatste meting tijdens de fling kan verouderd
            zijn, deze niet, want dan staat alles stil. Nodig omdat scrollend
            pas vanaf iOS 26.2 bestaat en daarvoor een lege huls is.
       Valt er een weg, dan houden de andere de balk goed. */
    var pid = bar.getAttribute('data-product-id');
    var inCart = false;
    var voorbij = false;
    var drawerEl = document.querySelector('#CartDrawer');

    /* Meetuitlezing, uitsluitend met ?mcatc=1 in de URL. Voor gewone
       bezoekers bestaat dit niet: geen element en geen timer. De twee
       aanjagers worden apart bijgehouden, zodat op een echt toestel te zien
       is welke van de twee een andere stand berekent dan de ander. */
    var meet = { io: 0, hermeet: 0, ioV: null, hmV: null, ioB: 0, hmB: 0 };
    var bron = 'start';
    var uitlees = null;

    function jn(v) { return v === null ? '-' : (v ? 1 : 0); }

    function teken() {
      if (!uitlees) return;
      var open = !!(drawerEl && drawerEl.classList.contains('drawer--is-open'));
      uitlees.textContent =
        'voorbij=' + (voorbij ? 1 : 0) +
        '  wagen=' + (inCart ? 1 : 0) +
        '  lade=' + (open ? 1 : 0) +
        '  zichtbaar=' + (bar.classList.contains('is-visible') ? 1 : 0) +
        '\nio=' + meet.io + ' zegt ' + jn(meet.ioV) + ' (bodem ' + meet.ioB + ')' +
        '\nhermeet=' + meet.hermeet + ' zegt ' + jn(meet.hmV) + ' (bodem ' + meet.hmB + ')' +
        '\nonder=' + (bar.style.bottom || '0px') + '  bron=' + bron;
    }

    if (location.search.indexOf('mcatc=1') !== -1) {
      uitlees = document.createElement('div');
      uitlees.setAttribute('style',
        'position:fixed;top:0;left:0;right:0;z-index:99999;background:#3B2F2A;' +
        'color:#F4EFE9;font:11px/1.4 ui-monospace,monospace;padding:6px 8px;' +
        'white-space:pre;pointer-events:none');
      document.body.appendChild(uitlees);
      setInterval(teken, 250);
    }

    function evalueer() {
      var open = !!(drawerEl && drawerEl.classList.contains('drawer--is-open'));
      bar.classList.toggle('mc-atc-off', inCart || open);
      bar.classList.toggle('is-visible', voorbij && !inCart && !open);
      teken();
    }

    /* a) De browser meldt zelf wanneer de knop de viewport verlaat. */
    var waarnemer = null;
    var ioLeeft = false;
    function koppelWaarnemer() {
      if (!('IntersectionObserver' in window)) return;
      if (waarnemer) waarnemer.disconnect();
      waarnemer = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        /* Niet-intersecterend zegt alleen dat de knop buiten beeld is, niet
           of dat boven of onder is. Bij naar boven scrollen ligt de knop
           onder de viewport en moet de balk juist weg. */
        var grens = e.rootBounds ? e.rootBounds.top : 0;
        ioLeeft = true;
        meet.io++;
        meet.ioB = Math.round(e.boundingClientRect.bottom);
        meet.ioV = !e.isIntersecting && e.boundingClientRect.bottom <= grens;
        voorbij = meet.ioV;
        bron = 'io';
        evalueer();
      }, { threshold: 0 });
      waarnemer.observe(realBtn);
    }
    koppelWaarnemer();

    /* b) Hermeten op een rustmoment. Het thema kan de knop bij een
       variantwissel opnieuw renderen; dan wijst realBtn naar een losgekoppeld
       element en moet de waarnemer mee verhuizen. verseKnop() doet dat
       zoeken, zodat de klik in de balk en deze meting dezelfde verwijzing
       gebruiken.

       Belangrijk: deze meting mag NIET schrijven terwijl er gescrold wordt en
       de waarnemer leeft. Op iOS loopt de scrollpositie die de main thread
       kent achter op wat er op het scherm staat, dus tijdens beweging geeft
       getBoundingClientRect() een verouderd antwoord -- naar beneden "nog
       niet voorbij", naar boven "nog steeds voorbij". Dat overschreef de
       correcte melding van de waarnemer en maakte het gedrag richting-
       afhankelijk. Tijdens beweging meet hij dus alleen mee voor de
       uitlezing; zodra alles stil ligt mag hij weer corrigeren. */
    var scrollt = false;

    function hermeet(welke) {
      var vers = verseKnop();
      if (!vers) return;
      if (vers !== realBtn) {
        realBtn = vers;
        koppelWaarnemer();
      }
      var bodem = realBtn.getBoundingClientRect().bottom;
      meet.hermeet++;
      meet.hmB = Math.round(bodem);
      meet.hmV = bodem <= 0;
      if (ioLeeft && scrollt) { teken(); return; }
      voorbij = meet.hmV;
      bron = welke || 'hermeet';
      evalueer();
    }

    ['touchend', 'scrollend', 'pageshow', 'orientationchange', 'resize'].forEach(function (naam) {
      window.addEventListener(naam, function () { hermeet(naam); }, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') hermeet('zichtbaar');
    });

    /* c+d) Scroll met een tijdslot in plaats van een grendel, plus een
       slotmeting zodra het scrollen stil ligt. Die slotmeting zet scrollt
       weer uit, zodat de hermeting daarna wel mag corrigeren. */
    var laatsteMeting = 0;
    var slot = null;
    window.addEventListener('scroll', function () {
      scrollt = true;
      var nu = Date.now();
      if (nu - laatsteMeting >= 100) {
        laatsteMeting = nu;
        hermeet('scroll');
      }
      clearTimeout(slot);
      slot = setTimeout(function () {
        scrollt = false;
        hermeet('scroll-einde');
      }, 150);
    }, { passive: true });

    function cartCheck() {
      if (!pid) { bron = 'wagen'; evalueer(); return; }
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var erin = false;
          for (var j = 0; j < c.items.length; j++) {
            if (String(c.items[j].product_id) === pid) { erin = true; break; }
          }
          inCart = erin;
          bron = 'wagen';
          evalueer();
        });
    }

    cartCheck();

    var drawerLijst = document.querySelector('#CartDrawer [data-products]');
    if (drawerLijst && 'MutationObserver' in window) {
      new MutationObserver(cartCheck).observe(drawerLijst, { childList: true, subtree: true });
    }
    if (drawerEl && 'MutationObserver' in window) {
      new MutationObserver(function () { bron = 'lade'; evalueer(); })
        .observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    /* --- de balk aan de visual viewport plakken ---------------------------
       bottom:0 rekent tegen de LAYOUT-viewport. Op iOS klapt Safari zijn
       onderbalk weg tijdens het scrollen; de onderkant van de layout-viewport
       ligt dan niet meer op de onderkant van wat de bezoeker ziet, en een
       balk die daaraan hangt staat op de verkeerde plek of buiten beeld.

       De visual viewport is wel het zichtbare deel. We verschuiven de balk
       met precies het verschil tussen de twee. Bewust via bottom en niet via
       een transform: een transform op een fixed element is nu juist het ding
       dat tijdens het scrollen niet wordt vastgelegd.

       Deze functie raakt de zichtbaarheidslogica niet aan; hij bepaalt alleen
       WAAR de balk staat, niet OF hij staat. Zonder de API gebeurt er niets
       en blijft de bottom:0 uit de CSS gelden. */
    var vviewport = window.visualViewport;

    function plak() {
      if (!vviewport) return;
      var onder = document.documentElement.clientHeight -
        (vviewport.offsetTop + vviewport.height);
      bar.style.bottom = (onder > 0 ? Math.round(onder) : 0) + 'px';
      teken();
    }

    if (vviewport) {
      /* resize vuurt wanneer Safari zijn balken weg- of terugklapt, scroll
         wanneer de bezoeker een ingezoomde pagina verschuift. Allebei zeldzaam
         vergeleken met scroll-events, dus dit kost per frame niets. */
      vviewport.addEventListener('resize', plak);
      vviewport.addEventListener('scroll', plak);
      plak();
    }

    var barBtn = bar.querySelector('[data-mc-sticky-btn]');
    var barPrice = bar.querySelector('[data-mc-sticky-price]');
    var barVariant = bar.querySelector('[data-mc-sticky-variant]');
    var barThumb = bar.querySelector('[data-mc-sticky-thumb]');

    var srcPrice = document.querySelector('[data-product-price]');

    // De balk hergebruikt de echte knop, zodat alle bestaande logica geldt.
    if (barBtn) {
      barBtn.addEventListener('click', function (e) {
        e.preventDefault();
        realBtn = verseKnop();
        if (realBtn) realBtn.click();
      });
    }

    function syncPrice() {
      if (barPrice && srcPrice) barPrice.textContent = srcPrice.textContent.trim();
    }

    function syncVariant() {
      var checked = document.querySelectorAll(
        '.variant-input-wrap input[type="radio"]:checked'
      );
      var parts = [];
      for (var i = 0; i < checked.length; i++) {
        if (bar.contains(checked[i])) continue;
        var v = checked[i].value;
        if (v) parts.push(v);
      }
      if (barVariant) barVariant.textContent = parts.join(' / ');

      // De gekozen kleurswatch is de variantfoto, dus die kan meteen als
      // miniatuur dienen.
      var swatch = document.querySelector(
        '.variant__input--color-swatch:checked + label img.aus-vimg'
      );
      if (swatch && barThumb && swatch.currentSrc) {
        barThumb.src = swatch.currentSrc;
      }
    }

    function syncAvailability() {
      if (!barBtn) return;
      barBtn.disabled = realBtn.disabled;
      var label = realBtn.querySelector('[data-add-to-cart-text]');
      var barLabel = barBtn.querySelector('[data-mc-sticky-btn-text]');
      if (label && barLabel) barLabel.textContent = label.textContent.trim();
    }

    /* Het thema kan de toevoegknop bij een variantwissel opnieuw renderen.
       De hermeting die dat vroeger opving is vervallen, dus halen we hier
       zelf een verse verwijzing; anders klikt de balkknop op een element dat
       niet meer in de pagina staat. */
    function verseKnop() {
      if (realBtn && document.contains(realBtn)) return realBtn;
      return zoekKnop() || realBtn;
    }

    function syncAll() {
      realBtn = verseKnop();
      syncPrice();
      syncVariant();
      syncAvailability();
    }

    syncAll();

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches('.variant-input-wrap input[type="radio"]')) {
        // De prijs wordt door het thema pas na de wissel bijgewerkt.
        setTimeout(syncAll, 0);
      }
    });

    if (srcPrice && 'MutationObserver' in window) {
      new MutationObserver(syncAll).observe(srcPrice, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  /* ------------------------------------------------------------------- 5 */

  /*
    VOIR PLUS. De knop is en blijft een gewone link naar de volgende pagina,
    dus zonder JavaScript werkt hij ook. Hier onderscheppen we de klik, halen
    we de volgende pagina op en plakken we alleen de productkaarten onder het
    bestaande raster.
  */
  function initLoadMore() {
    var wrap = document.querySelector('[data-mc-loadmore]');
    if (!wrap) return;

    var btn = wrap.querySelector('[data-mc-loadmore-btn]');
    var label = wrap.querySelector('[data-mc-loadmore-label]');
    var counter = wrap.querySelector('[data-mc-loadmore-count]');
    var grid = document.querySelector('.collection-grid__wrapper .grid--uniform');
    if (!btn || !grid || !('fetch' in window)) return;

    var busy = false;
    var original = label ? label.textContent : '';

    btn.addEventListener('click', function (e) {
      if (busy) { e.preventDefault(); return; }
      var url = btn.getAttribute('href');
      if (!url) return;

      e.preventDefault();
      busy = true;
      btn.setAttribute('aria-busy', 'true');
      if (label) label.textContent = label.getAttribute('data-loading') || '...';

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('.collection-grid__wrapper .grid--uniform > .grid-product');
          for (var i = 0; i < items.length; i++) {
            grid.appendChild(document.importNode(items[i], true));
          }

          // De volgende knop uit de opgehaalde pagina bepaalt hoe het verder gaat.
          var nextWrap = doc.querySelector('[data-mc-loadmore]');
          var nextBtn = nextWrap ? nextWrap.querySelector('[data-mc-loadmore-btn]') : null;
          var nextCount = nextWrap ? nextWrap.querySelector('[data-mc-loadmore-count]') : null;

          if (nextBtn && nextBtn.getAttribute('href')) {
            btn.setAttribute('href', nextBtn.getAttribute('href'));
            if (counter && nextCount) counter.textContent = nextCount.textContent.trim();
            if (label) label.textContent = original;
          } else {
            // Laatste pagina bereikt.
            wrap.parentNode.removeChild(wrap);
          }

          // Lazy images die het thema zelf beheert een zetje geven.
          if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
            window.theme.reinitProductGridItem(grid);
          }
          window.dispatchEvent(new Event('scroll'));
        })
        .catch(function () {
          // Bij een fout laten we de knop een gewone link zijn, zodat de
          // bezoeker alsnog verder kan.
          if (label) label.textContent = original;
          window.location.href = url;
        })
        .then(function () {
          busy = false;
          btn.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------------------------------------------------------------- start */

  /* ------------------------------------------------ gekozen maat in het label

     Het kleurlabel wordt door het thema zelf bijgewerkt, want dat heeft een
     eigen haak. Voor de overige opties, in de praktijk de maat, is er niets,
     dus dat doen we hier. Een gedelegeerde luisteraar op document, zodat het
     ook werkt als de variantkiezer opnieuw getekend wordt. */

  function initOptionLabels() {
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.hasAttribute || !input.hasAttribute('data-variant-input')) return;

      var wrap = input.closest('.variant-wrapper');
      if (!wrap || wrap.classList.contains('variant-wrapper--color')) return;

      var out = wrap.querySelector('[data-variant-option-label]');
      if (out) out.textContent = input.value;
    });
  }

  /* -------------------------------------------- reserveringstellers (10 min)

     Elke [data-mc-hold] krijgt zijn eigen aftelling. Op nul verdwijnt de balk
     en stopt het interval; er wordt niets meer aangeraakt, dus er valt ook
     niets te crashen. Voor de lade, die pas na het laden in beeld komt, is
     dat geen probleem: de markup staat er al vanaf het begin. */

  function initHoldTimers() {
    var boxes = document.querySelectorAll('[data-mc-hold]');

    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.mcHoldStarted) return;
      box.dataset.mcHoldStarted = '1';

      var out = box.querySelector('[data-mc-hold-time]');
      if (!out) return;

      var left = parseInt(box.getAttribute('data-mc-hold-seconds'), 10);
      if (!left || left < 1) left = 600;

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function paint() {
        out.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
      }

      paint();

      var tick = setInterval(function () {
        left -= 1;

        if (left <= 0) {
          clearInterval(tick);
          box.hidden = true;
          return;
        }

        paint();
      }, 1000);
    });
  }

  /* ------------------------------------------------------ trapbalk in de lade

     B2: de kortingstrappen volgen cart.item_count. De lade rendert zijn
     itemlijst server-side opnieuw bij elke wijziging (/cart?view=ajax), dus
     een MutationObserver op die lijst is het betrouwbare signaal; we hangen
     niet aan themaspecifieke events. Na elke wijziging halen we /cart.js op
     voor het aantal en het totaal, en tellen we de doorgestreepte regel-
     totalen op uit data-mc-line-compare, want compare-at zit niet in
     /cart.js. */

  function initCartSteps() {
    var lijst = document.querySelector('#CartDrawer [data-products]');
    var steps = document.querySelector('#CartDrawer [data-mc-steps]');
    if (!lijst || !steps) return;

    var euro = function (c) {
      return '€' + (c / 100).toFixed(2).replace('.', ',');
    };

    /* data-msg-0 is via dataset niet bereikbaar (een streepje voor een
       cijfer camelcaset niet), dus getAttribute. */
    function boodschap(n) {
      return n >= 4
        ? steps.getAttribute('data-msg-max')
        : steps.getAttribute('data-msg-' + n);
    }

    var bezig = false;

    function verwerk() {
      if (bezig) return;
      bezig = true;

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = cart.item_count;

          steps.querySelectorAll('[data-mc-step]').forEach(function (st) {
            st.classList.toggle('is-done', n >= parseInt(st.dataset.mcStep, 10));
          });

          var fill = steps.querySelector('[data-mc-steps-fill]');
          if (fill) fill.style.width = Math.min(n, 4) * 25 + '%';

          var msg = steps.querySelector('[data-mc-steps-message]');
          if (msg) msg.textContent = boodschap(n);

          /* voetregel: besparing en oude prijs */
          var compare = 0;
          lijst.querySelectorAll('[data-mc-line-compare]').forEach(function (el) {
            compare += parseInt(el.dataset.mcLineCompare, 10) || 0;
          });
          var besparing = (compare - cart.items_subtotal_price) + cart.total_discount;

          var sav = document.querySelector('[data-mc-total-savings]');
          var cmp = document.querySelector('[data-mc-total-compare]');
          if (sav && cmp) {
            if (besparing > 0) {
              sav.hidden = false; cmp.hidden = false;
              sav.textContent = 'ÉCONOMISEZ ' + euro(besparing);
              cmp.textContent = euro(cart.total_price + besparing);
            } else {
              sav.hidden = true; cmp.hidden = true;
            }
          }

          /* Het totaalbedrag staat sinds deze ronde in de afrekenknop. */
          var btnTotal = document.querySelector('#CartDrawer [data-mc-btn-total]');
          if (btnTotal) btnTotal.textContent = euro(cart.total_price);
        })
        .finally(function () { bezig = false; });
    }

    new MutationObserver(verwerk).observe(lijst, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------- pijlen bij de reviews

     C2/C4: twee ronde knoppen sturen de kaartenrij; een klik schuift precies
     een kaart (kaartbreedte plus de 24px gap van de rij). */

  function initTstmArrows() {
    /* Gedelegeerd op document, zodat het ook werkt wanneer de sectie later
       opnieuw gerenderd wordt (thema-editor, section rendering API). */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-mc-tstm-prev], [data-mc-tstm-next]');
      if (!btn) return;

      var sectie = btn.closest('.shopify-section') || document;
      var rij = sectie.querySelector('.mc-tstm__list');
      if (!rij) return;

      var kaart = rij.querySelector('.mc-tstm__card');
      var stap = (kaart ? kaart.getBoundingClientRect().width : rij.clientWidth) + 24;
      if (btn.hasAttribute('data-mc-tstm-prev')) stap = -stap;

      /* Geen behavior:'smooth' hier: op deze container weigerde de browser
         de programmatische smooth-scroll volledig (scrollLeft bleef 0). De
         rij heeft scroll-behavior: smooth in de CSS, dus een kale scrollBy
         animeert alsnog; precies zo doet de referentie het ook. */
      rij.scrollBy(stap, 0);
    });
  }

  function init() {
    initDailyCountdown();
    initStickyAtc();
    initLoadMore();
    initOptionLabels();
    initHoldTimers();
    initCartSteps();
    initTstmArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
